module.exports = __webpack_public_path__ + "img/MX.b2c7de57.jpg";